import { NavLink } from 'react-router-dom';

import { useCan } from '../../stores/session';

/**
 * Navigation between the admin pages.
 *
 * They had none: `/admin/audit` was reachable only by typing it, which is how a
 * moderation surface ends up unused by the people it was built for.
 *
 * Each link is gated on the permission its page requires, so a moderator who
 * can see reports but not the audit log is offered exactly what they can open -
 * rather than a link that renders a "you cannot see this" page.
 */
export function AdminNav() {
  const canReports = useCan('report.view');
  const canDmca = useCan('dmca.view');
  const canHosts = useCan('host.review');
  const canAudit = useCan('audit.view');

  return (
    <nav className="flex flex-wrap gap-1 border-b border-line pb-3" aria-label="Admin sections">
      <Item to="/admin" end>
        Users
      </Item>
      {canReports && <Item to="/admin/reports">Reports</Item>}
      {canDmca && <Item to="/admin/dmca">Claims</Item>}
      {canHosts && <Item to="/admin/host-applications">Hosts</Item>}
      {canAudit && <Item to="/admin/audit">Audit log</Item>}
    </nav>
  );
}

function Item({ to, end = false, children }: { to: string; end?: boolean; children: string }) {
  return (
    <NavLink
      to={to}
      // `end` on the index route only, or /admin stays highlighted on every
      // page beneath it.
      end={end}
      className={({ isActive }) =>
        `rounded-[var(--radius-pill)] px-4 py-2 text-sm transition-colors ${
          isActive ? 'bg-raised font-medium text-ink' : 'text-soft hover:text-ink'
        }`
      }
    >
      {children}
    </NavLink>
  );
}
